/**
 * A personal scratch-card prize code, recognised by its prefix alone.
 *
 * The recognition has to be synchronous — the `?code=` carrier strips the code
 * from the address bar before anything awaits (the browser half of
 * `plugins/3.urlCoupon`),
 * so it cannot wait for `couponPreview` to tell it what kind of code it has.
 *
 * Lives in the common layer because `useAnalytics` (layer) filters prize codes
 * out of the GA4 `coupon` parameter. Auto-imported in the app; pure modules
 * import it explicitly (`@layers/common/app/utils/prizeCode`).
 */

/** Mirrors GWO/prize-code.ts GIFT_PRIZE_CODE_PREFIX; keep the two in step. */
export const PRIZE_CODE_PREFIX = 'PRIZE'

export function isPrizeCode(code: string | null | undefined): boolean {
  return typeof code === 'string' && code.trim().toUpperCase().startsWith(PRIZE_CODE_PREFIX)
}
